/**
 * Pure helpers extracted from AnnotationsLayer so they can be unit-tested
 * without importing React (the studio's vitest runs in node env).
 */

export interface HighlightRange {
  charStartInBlock: number;
  charEndInBlock: number;
  quote?: string;
}

export interface AnnotationLike {
  range_json: string;
}

export function highlightKey(range: HighlightRange): string {
  return range.quote?.trim()
    ? `quote:${range.quote.trim()}`
    : `offset:${range.charStartInBlock}:${range.charEndInBlock}`;
}

export function firstAnnotationQuote(annotations: AnnotationLike[]): string | null {
  return (
    annotations
      .map((annotation) => {
        try {
          return (JSON.parse(annotation.range_json) as { quote?: string }).quote?.trim();
        } catch {
          return undefined;
        }
      })
      .find((value): value is string => Boolean(value)) ?? null
  );
}

export function labelForKind(kind: "comment" | "tag", count: number): string {
  if (kind === "comment") return count === 1 ? "1 comentario" : `${count} comentarios`;
  return count === 1 ? "1 etiqueta" : `${count} etiquetas`;
}
